import "./util.scss";

export const ChatBox = ({ children, ...delegated }) => {
  return <div {...delegated}>{children}</div>;
};
